// Page view analytics tracking
window.DiffBlogAnalytics = {
  trackPageView: function(pageViewId) {
    if (!pageViewId) return;
    
    let startTime = Date.now();
    let maxScroll = 0;
    let hasScrolled = false;
    let dataSent = false;
    
    // Track scroll depth
    function updateScrollDepth() {
      const scrollPercent = Math.round((window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100);
      if (scrollPercent > maxScroll) {
        maxScroll = Math.min(100, scrollPercent);
        hasScrolled = true;
      }
    }
    
    // Send analytics data
    function sendAnalytics(exitMethod) {
      if (dataSent) return; // Prevent duplicate sends
      
      const timeSpent = Math.round((Date.now() - startTime) / 1000);
      
      if (timeSpent < 3) return; // Skip very short visits
      
      dataSent = true;
      
      fetch('/api/analytics/page_view', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          page_view_id: pageViewId,
          time_spent: timeSpent,
          scroll_depth: maxScroll,
          exit_method: exitMethod
        })
      }).catch(() => {}); // Ignore errors
    }
    
    // Event listeners
    window.addEventListener('scroll', updateScrollDepth);
    window.addEventListener('beforeunload', () => sendAnalytics('navigation'));
    
    // Send data periodically for long reads
    const intervalId = setInterval(() => {
      if (hasScrolled && !dataSent) {
        sendAnalytics('timeout');
        clearInterval(intervalId);
      }
    }, 30000);
    
    // Clear interval when page is hidden (mobile browsers)
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && !dataSent) {
        sendAnalytics('visibility_change');
        clearInterval(intervalId);
      }
    });
  }
};